export const isFulfilled = (promise) => promise.status === 'fulfilled';
export const isRejected = (promise) => promise.status === 'rejected';
export const isResolvedErr = (promise) => 'value' in promise && promise.value.isErr();
